var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiveMoneyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_567_1648)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_567_1648",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 55,
    height: 55
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.00390625 -0.000972748H53.9961V53.999H-0.00390625V-0.000972748Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_567_1648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6063 27.7842C19.6063 25.2619 17.5653 23.2209 15.043 23.2209",
    stroke: "#9E3223",
    strokeWidth: 2.10937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6191 27.7842C46.6191 25.2619 48.6602 23.2209 51.1825 23.2209",
    stroke: "#9E3223",
    strokeWidth: 2.10937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6191 8.50797C46.6191 11.0303 48.6602 13.0713 51.1825 13.0713",
    stroke: "#9E3223",
    strokeWidth: 2.10937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1133 8.43639H49.5427C50.4878 8.43639 51.2539 9.20252 51.2539 10.1476V26.1437C51.2539 27.0889 50.4878 27.855 49.5427 27.855H37.8594",
    stroke: "#9E3223",
    strokeWidth: 2.10937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3672 27.856H16.6839C15.7389 27.856 14.9727 27.0898 14.9727 26.1447V16.9865",
    stroke: "#9E3223",
    strokeWidth: 2.10937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5731 15.754C29.4343 14.1268 31.1445 13.0182 33.1137 13.0182C35.9489 13.0182 38.2474 15.3166 38.2474 18.1518C38.2474 20.9872 35.9489 23.2856 33.1137 23.2856C30.9391 23.2856 29.0803 21.9336 28.332 20.0243",
    stroke: "#9E3223",
    strokeWidth: 2.10937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.332 2.74078H25.6256C27.1275 2.74078 28.5872 3.23817 29.7766 4.15533L35.3281 8.4361H23.8593C22.6501 8.4361 21.6699 9.41632 21.6699 10.6255C21.6699 11.4221 22.1027 12.1559 22.7997 12.5414L28.2259 15.5424C29.3509 16.1645 29.851 17.5166 29.4017 18.7212C28.965 19.8921 27.756 20.5856 26.5249 20.3716L22.715 19.7091C19.1668 19.0921 15.8011 17.6911 12.8633 15.608H10.332",
    stroke: "#9E3223",
    strokeWidth: 2.10937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.332 17.9287H1.05078V1.05371H10.332V17.9287Z",
    stroke: "#9E3223",
    strokeWidth: 2.10937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6537 51.6787H22.9914C19.3371 51.6787 15.8325 50.227 13.2485 47.6431L7.51867 41.9133C6.49298 40.8876 6.49688 39.2233 7.52742 38.2023C8.5512 37.188 10.2023 37.1921 11.2213 38.2112L16.3483 43.3397C18.0666 45.0584 20.3972 46.0241 22.8276 46.0241H28.5251",
    stroke: "#9E3223",
    strokeWidth: 2.10937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7478 46.0239H23.2631C21.8213 46.0239 20.6523 44.855 20.6523 43.413C20.6523 41.9712 21.8213 40.8023 23.2631 40.8023H29.9222L31.2996 39.1672C33.0136 37.1326 35.5383 35.9583 38.1986 35.9583C40.1018 35.9583 41.9563 36.5602 43.4967 37.6781L43.65 37.7893",
    stroke: "#9E3223",
    strokeWidth: 2.10937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9414 52.9443H43.6602V36.0693H52.9414V52.9443Z",
    stroke: "#9E3223",
    strokeWidth: 2.10937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_567_1648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiveMoneyIcon);
export default __webpack_public_path__ + "static/media/give-money-icon.c2e7b4cfca49499cd8b5478c13b0950e.svg";
export { ForwardRef as ReactComponent };